import mx from './factory'
import {
  mxCell as typeMxCell,
  mxPopupMenuHandler,
  mxEventObject as typeMxEventObject,
  mxCellState as typeMxCellState,
  mxEventSource
} from 'mxgraph'
import { Action } from './actions'
import myStyle from './defaultStyle'
import { nanoid } from 'nanoid'
import { ctrlKey, keyCode } from './defaultConfig'
import { isProxy } from 'vue'
import { NodeConfig } from './type/type'
import { Canvg } from 'canvg'
import html2canvas from 'html2canvas'
import domtoimage from 'dom-to-image'
import mxIcon from './mxIcon'
const {
  mxGraph,
  mxRubberband,
  mxEventObject,
  mxGeometry,
  mxKeyHandler,
  mxGraphHandler,
  mxEvent,
  mxConstants,
  mxEdgeHandler,
  mxCell,
  mxCellState,
  mxShape,
  mxPoint,
  mxConnectionConstraint,
  mxVertexHandler,
  mxImage
} = mx

class MyGraph extends mxGraph {
  gridColor: string = '#d0d0d0'
  showGrid: boolean = true
  rubberband = new mxRubberband(this)
  keyHandler = new mxKeyHandler(this)
  currentEdge?: {
    style: string
    panelId: string
  }
  actions: Action
  createVertexStatus: boolean = false
  createEdgeStatus: boolean = false
  nodeProps: any
  edgeProps: any
  lineStyle?: Record<string, string>[]
  cellRightClick?: (cells: typeMxCell[], menu: mxPopupMenuHandler) => void
  handleAddVertex?: (
    cell: typeMxCell,
    x: number,
    y: number,
    target: typeMxCell
  ) => void
  handleDeleteCell?: (cell: typeMxCell) => void
  handleAddEdge?: (cell: typeMxCell) => void
  handleDropIn?: (target: typeMxCell, cells: typeMxCell[]) => void
  handleDropOut?: (target: typeMxCell, cells: typeMxCell[]) => void
  handleMoveCell?: (cell: typeMxCell) => void
  handleSizeChange?: (props: {
    x: string
    y: string
    width: string
    height: string
    id: string
  }) => void
  handleRotate?: (cell: typeMxCell) => void
  beforeDeleteCell?: (cell: typeMxCell) => boolean
  beforeAddVertex?: (cell: typeMxCell) => boolean
  currentState?: typeMxCellState
  currentIcon?: mxIcon
  showHoverIcon?: boolean
  hoverIconHandler?: (
    type: string,
    evt: MouseEvent,
    cell: typeMxCellState
  ) => void
  // menuClick?:()
  constructor(container: HTMLElement) {
    super(container)
    this.actions = new Action(this)
    this.actions.init()
  }
  _init() {
    //右键平移
    this.setPanning(true)
    this._setAnchors()
    this._setDefaultConfig()
    this._setDefaultEdgeStyle()
    this._rightClickMenu()
    // this._setDrop()
    this.setGrid()
    this._initActionState()
    this.keyHandler.actions = this.actions
    this._initKeyHandler()
    this.addUndoListener()
    /**监听状态变化 */
    this.getSelectionModel().addListener(mxEvent.CHANGE, () => {
      this._initActionState()
    })
    this.getModel().addListener(mxEvent.CHANGE, () => {
      this._initActionState()
    })

    this.listenRotation()
    this._initHoverIcon()
  }
  _setDefaultConfig() {
    // cell style editable 控制是否可以双击编辑
    this.setConnectable(true)
    mxEvent.disableContextMenu(this.container)
    // 固定节点大小
    this.setCellsResizable(false)
    // // 编辑时按回车键不换行，而是完成输入
    // this.setEnterStopsCellEditing(true)
    // // 编辑时按 escape 后完成输入
    // mxCellEditor.prototype.escapeCancelsEditing = false
    // // 失焦时完成输入
    // mxCellEditor.prototype.blurEnabled = true
    // // 禁止节点折叠
    // this.foldingEnabled = false
    // // 文本包裹效果必须开启此配置
    this.setHtmlLabels(true)

    // // 拖拽过程对齐线
    mxGraphHandler.prototype.guidesEnabled = true

    // // 禁止游离线条
    this.setDisconnectOnMove(false)
    // this.setAllowDanglingEdges(false)
    // mxGraph.prototype.isCellMovable=function = cell => !cell.edge

    // // 禁止调整线条弯曲度
    // this.setCellsBendable(false)

    // // 禁止从将label从线条上拖离
    mxGraph.prototype.edgeLabelsMovable = false
    // 样式
    myStyle.children.forEach((ele: any) => {
      const node: { [k: string]: string } = {}
      ele.children.forEach((element: any) => {
        node[element.attributes.as] = element.attributes.value
      })
      this.getStylesheet().putCellStyle(ele.attributes.as, node)
    })
  }
  _setDefaultEdgeStyle() {
    const style = this.getStylesheet().getDefaultEdgeStyle()
    Object.assign(style, {
      // [mxConstants.STYLE_ROUNDED]: true, // 设置线条拐弯处为圆角
      [mxConstants.STYLE_STROKEWIDTH]: '2',
      [mxConstants.STYLE_STROKECOLOR]: '#333333',
      // [mxConstants.STYLE_EDGE]: mxConstants.EDGESTYLE_ORTHOGONAL,
      [mxConstants.STYLE_FONTCOLOR]: '#33333',
      [mxConstants.STYLE_EDITABLE]: '0'
      // [mxConstants.STYLE_LABEL_BACKGROUNDCOLOR]: '#ffa94d',
    })

    mx.mxEdgeHandler.prototype.handleImage = new mx.mxImage(
      'images/handle-main.png',
      17,
      17
    )

    style[mxConstants.STYLE_EDGE] = 'orthogonalEdgeStyle'
    // 设置拖拽线的过程出现折线，默认为直线
    this.connectionHandler.createEdgeState = () => {
      const edge = this.createEdge(
        this.defaultParent,
        null,
        '',
        new mxCell(),
        new mxCell()
      )
      edge.connectable = true
      return new mxCellState(this.view, edge, this.getCellStyle(edge))
    }
  }
  _initKeyHandler() {
    for (const key in this.actions.action) {
      if (Object.hasOwnProperty.call(this.actions.action, key)) {
        const action = this.actions.action[key]
        const shortcutKey = action.shortcutKey
        if (shortcutKey) {
          const keyArray = shortcutKey.split('+')
          const isCtrl = keyArray.includes(ctrlKey)
          const isShift = keyArray.includes('Shift')
          const isDownKey =
            keyArray[keyArray.length - 1] === '加'
              ? '+'
              : keyArray[keyArray.length - 1]
          const downKey = keyCode[isDownKey]
          this.keyHandler.bindAction(downKey, isCtrl, key, isShift)
        }
      }
    }
  }
  _setDrop() {
    this.setDropEnabled(true)
    this.isValidDropTarget = function (target, cells, evt) {
      if (target.info && target.info.type === 'combo') {
        return true
      }
      return false
    }
  }
  /**
   * 初始化大部分action的是否可用状态
   * toolbar是否可用操作通过这个函数进行状态管理
   */
  _initActionState() {
    let selected = !this.isSelectionEmpty()
    let vertexSelected = false
    let groupSelected = false
    let edgeSelected = false
    const cells = this.getSelectionCells()
    if (cells != null) {
      for (var i = 0; i < cells.length; i++) {
        var cell = cells[i]

        if (this.getModel().isEdge(cell)) {
          edgeSelected = true
        }

        if (this.getModel().isVertex(cell)) {
          vertexSelected = true

          if (this.getModel().getChildCount(cell) > 0) {
            groupSelected = true
          }
        }

        if (edgeSelected && vertexSelected) {
          break
        }
      }
    }
    const actions = ['cut', 'copy', 'delete', 'toFront', 'toBack']
    for (var i = 0; i < actions.length; i++) {
      this.actions.get(actions[i]).setEnabled(selected)
    }
    var oneVertexSelected = vertexSelected && this.getSelectionCount() == 1
    this.actions
      .get('group')
      .setEnabled(this.getSelectionCount() > 1 || oneVertexSelected)
    this.actions.get('ungroup').setEnabled(groupSelected)
  }
  _setAnchors() {
    // 禁止从节点中心拖拽出线条
    // this.connectionHandler.isConnectableCell = () => false
    mxEdgeHandler.prototype.isConnectableCell = () => false

    // hover时显示连接节点
    mxGraph.prototype.getAllConnectionConstraints = (terminal) => {
      if (terminal != null && terminal.cell != null && terminal.cell.isEdge())
        return []
      if (terminal != null && terminal.shape != null) {
        if (terminal.shape.stencil != null) {
          if (terminal.shape.stencil != null) {
            return terminal.shape.stencil.constraints
          }
        } else if (terminal.shape.constraints != null) {
          return terminal.shape.constraints
        }
      }

      return []
    }

    //设计连接节点
    mxShape.prototype.constraints = [
      new mxConnectionConstraint(new mxPoint(0, 0), true),
      new mxConnectionConstraint(new mxPoint(0, 1), true),
      new mxConnectionConstraint(new mxPoint(1, 0), true),
      new mxConnectionConstraint(new mxPoint(1, 1), true),
      new mxConnectionConstraint(new mxPoint(0.25, 0), true),
      new mxConnectionConstraint(new mxPoint(0.5, 0), true),
      new mxConnectionConstraint(new mxPoint(0.75, 0), true),
      new mxConnectionConstraint(new mxPoint(0, 0.25), true),
      new mxConnectionConstraint(new mxPoint(0, 0.5), true),
      new mxConnectionConstraint(new mxPoint(0, 0.75), true),
      new mxConnectionConstraint(new mxPoint(1, 0.25), true),
      new mxConnectionConstraint(new mxPoint(1, 0.5), true),
      new mxConnectionConstraint(new mxPoint(1, 0.75), true),
      new mxConnectionConstraint(new mxPoint(0.25, 1), true),
      new mxConnectionConstraint(new mxPoint(0.5, 1), true),
      new mxConnectionConstraint(new mxPoint(0.75, 1), true)
    ]
  }
  _initRotate() {
    const rotationHandle = new mxImage(
      'data:image/png;base64,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',
      19,
      21
    )
    mxVertexHandler.prototype.rotationEnabled = true

    var vertexHandlerCreateSizerShape =
      mxVertexHandler.prototype.createSizerShape
    mxVertexHandler.prototype.createSizerShape = function (
      bounds,
      index,
      fillColor
    ) {
      this.handleImage =
        index == mxEvent.ROTATION_HANDLE ? rotationHandle : this.handleImage

      return vertexHandlerCreateSizerShape.apply(this, [
        bounds,
        index,
        fillColor
      ])
    }
  }
  _rightClickMenu() {
    this.popupMenuHandler.autoExpand = true
    this.popupMenuHandler.factoryMethod = (menu, cell, evt) => {
      const cells = this.getSelectionCells()
      if (cells.length > 0) {
        if (this.cellRightClick) {
          this.cellRightClick(cells, menu)
        }
        menu.addItem(
          '删除',
          undefined,
          this.actions.get('delete').func.bind(this, this)
        )
      }
    }
  }
  _initHoverIcon() {
    const _that = this
    this.addMouseListener({
      mouseDown: function (sender, me) {
        // Hides icons on mouse down
        if (_that.currentState && _that.showHoverIcon) {
          _that.dragLeave(me.getEvent(), _that.currentState)
          _that.currentState = undefined
        }
      },
      mouseMove: function (sender, me) {
        if (!_that.showHoverIcon) return
        if (
          _that.currentState != null &&
          (me.getState() == _that.currentState || me.getState() == null)
        ) {
          var tol = 20
          let tmp = new mx.mxRectangle(
            me.getGraphX() - tol,
            me.getGraphY() - tol,
            2 * tol,
            2 * tol
          )

          if (mx.mxUtils.intersects(tmp, _that.currentState)) {
            return
          }
        }

        let tmp: typeMxCellState | null = _that.view.getState(me.getCell())

        // Ignores everything but vertices
        if (
          _that.isMouseDown ||
          (tmp != null && !_that.getModel().isVertex(tmp.cell))
        ) {
          tmp = null
        }

        if (tmp != _that.currentState) {
          if (_that.currentState != null) {
            _that.dragLeave(me.getEvent(), _that.currentState)
          }

          _that.currentState = tmp ? tmp : undefined

          if (_that.currentState != null) {
            _that.dragEnter(me.getEvent(), _that.currentState)
          }
        }
      },
      mouseUp: function (sender, me) {}
    })
  }
  dragEnter(evt: MouseEvent, state: typeMxCellState) {
    console.log(evt, state)

    if (!this.currentIcon) {
      this.currentIcon = new mxIcon(state)
      this.currentIcon.handle = this.hoverIconHandler
      // this.currentIconSet = this.currentIconSet
    }
  }
  dragLeave(evt: MouseEvent, state: typeMxCellState) {
    if (this.currentIcon != null) {
      this.currentIcon.destroy()
      this.currentIcon = undefined
    }
  }
  /**
   * 创建背景grid svg
   * @param {string}} color grid的颜色
   */
  createSvgGrid() {
    var tmp = this.gridSize * this.getView().scale
    const color = this.gridColor
    while (tmp < 4) {
      tmp *= 2
    }

    var tmp2 = 4 * tmp

    // Small grid lines
    var d = []

    for (var i = 1; i < 4; i++) {
      var tmp3 = i * tmp
      d.push(
        'M 0 ' +
          tmp3 +
          ' L ' +
          tmp2 +
          ' ' +
          tmp3 +
          ' M ' +
          tmp3 +
          ' 0 L ' +
          tmp3 +
          ' ' +
          tmp2
      )
    }

    // KNOWN: Rounding errors for certain scales (eg. 144%, 121% in Chrome, FF and Safari). Workaround
    // in Chrome is to use 100% for the svg size, but this results in blurred grid for large diagrams.
    var size = tmp2
    var svg =
      '<svg width="' +
      size +
      '" height="' +
      size +
      '" xmlns="' +
      mxConstants.NS_SVG +
      '">' +
      '<defs><pattern id="grid" width="' +
      tmp2 +
      '" height="' +
      tmp2 +
      '" patternUnits="userSpaceOnUse">' +
      '<path d="' +
      d.join(' ') +
      '" fill="none" stroke="' +
      color +
      '" opacity="0.2" stroke-width="1"/>' +
      '<path d="M ' +
      tmp2 +
      ' 0 L 0 0 0 ' +
      tmp2 +
      '" fill="none" stroke="' +
      color +
      '" stroke-width="1"/>' +
      '</pattern></defs><rect width="100%" height="100%" fill="url(#grid)"/></svg>'

    return svg
  }
  /**设置Grid */
  setGrid() {
    const svg = this.createSvgGrid()
    let image = ''
    image = unescape(encodeURIComponent(svg))
    image = btoa(image)
    image = 'url(' + 'data:image/svg+xml;base64,' + image + ')'
    this.container.style.backgroundImage = `${image}`
  }
  sidebarToGraph(
    dragCell: typeMxCell,
    x: number,
    y: number,
    target: typeMxCell
  ) {
    this.getModel().beginUpdate()
    try {
      if (this.beforeAddVertex && !this.beforeAddVertex(dragCell)) return
      dragCell.id = this.model.createId(dragCell)
      this.createVertexStatus = true
      //error
      const cell = this.importCells([dragCell], x, y, target)
      this.setSelectionCells(cell)
      this.createVertexStatus = false
      this.handleAddVertex && this.handleAddVertex(cell[0], x, y, target)
    } finally {
      this.getModel().endUpdate()
    }
    // this.refresh()
  }
  insertVertetByConfig(cfg: NodeConfig) {
    let parent = this.getDefaultParent()
    if (cfg.parentId) {
      parent = this.findById(cfg.parentId) as typeMxCell
    }
    const cell = this.insertVertex(
      parent,
      cfg.id,
      cfg.value ? cfg.value : '',
      cfg.x,
      cfg.y,
      cfg.width,
      cfg.height,
      cfg.style,
      undefined
    )
    cell.info = cfg.info
    return cell
  }
  insertEdge(
    parent: typeMxCell,
    id: string | null,
    value: any,
    source: typeMxCell,
    target: typeMxCell,
    style?: string | undefined
  ): typeMxCell {
    let edge = this.createEdge(parent, id, value, source, target, style)
    edge = this.addEdge(edge, parent, source, target)
    if (!this.createEdgeStatus) {
      this.handleAddEdge && this.handleAddEdge(edge)
    }
    return edge
  }
  moveCells(
    cells: typeMxCell[],
    dx: number,
    dy: number,
    clone: boolean,
    target?: typeMxCell | undefined,
    evt?: Event | undefined,
    mapping?: any
  ) {
    cells = mxGraph.prototype.moveCells.call(
      this,
      cells,
      dx,
      dy,
      clone,
      target,
      evt,
      mapping
    )
    if (target) {
      if (target.id === '1') {
        this.handleDropOut && this.handleDropOut(target, cells)
      } else {
        this.handleDropIn && this.handleDropIn(target, cells)
      }
    }
    if (!this.createVertexStatus) {
      cells.forEach((ele) => {
        this.handleMoveCell && this.handleMoveCell(ele)
      })
    }
    return cells
  }
  findById(id: string | ((cell: typeMxCell) => boolean)) {
    const cells = this.getAllCells()
    const cell = cells.find((ele) => {
      if (typeof id === 'string') {
        return ele.id === id
      } else {
        return id(ele)
      }
    })
    return cell
  }
  getAllCells(): typeMxCell[] {
    const cells: typeMxCell[] = []
    for (const key in this.model.cells) {
      if (Object.prototype.hasOwnProperty.call(this.model.cells, key)) {
        const element = this.model.cells[key]
        if (key !== '0' && key !== '1') {
          cells.push(element)
        }
      }
    }
    return cells
  }
  deleteCells(cells: typeMxCell[]) {
    if (cells.length > 0) {
      for (let i = 0; i < cells.length; i++) {
        const ele = cells[i]
        let flag = true
        if (this.beforeDeleteCell) {
          flag = this.beforeDeleteCell(ele)
        }
        if (flag) {
          this.removeCells([ele])
          this.handleDeleteCell && this.handleDeleteCell(ele)
        }
      }
    }
  }
  insertEdgeByConfig(cfg: NodeConfig) {
    const cell = this.insertEdge(
      this.defaultParent,
      cfg.id ? cfg.id : null,
      cfg.value,
      cfg.source as typeMxCell,
      cfg.target as typeMxCell,
      cfg.style
    )
    return cell
  }
  /**
   * 撤回和取消撤回的监听函数
   */
  addUndoListener() {
    const undo = this.actions.get('undo')
    const redo = this.actions.get('redo')

    const undoMgr = this.actions.undoManager

    const undoListener = () => {
      undo.setEnabled(this.canUndo())
      redo.setEnabled(this.canRedo())
    }

    undoMgr.addListener(mxEvent.ADD, undoListener)
    undoMgr.addListener(mxEvent.UNDO, undoListener)
    undoMgr.addListener(mxEvent.REDO, undoListener)
    undoMgr.addListener(mxEvent.CLEAR, undoListener)

    // Updates the button states once
    undoListener()
  }
  /**
   * 是否可以撤回
   */
  canUndo() {
    return this.isEditing() || this.actions.undoManager.canUndo()
  }
  /**
   * 是否可以取消撤回
   */
  canRedo() {
    return this.isEditing() || this.actions.undoManager.canRedo()
  }
  /**监听rotate */
  listenRotation() {
    this.addListener('rotate', (params) => {
      if (this.handleRotate) {
        this.handleRotate(params)
      }
    })
  }
  exportImage() {
    const { root, w, h } = this.getSvg('#ffffff')
    this.svgToPng(root as SVGElement, w, h)
  }
  /**
   * 将svg dom转换为canvas下载
   * @param {HTMLDom} svg svg dom
   */
  svgToPng(svg: SVGElement, w: number, h: number) {
    // const canvas = document.createElement('canvas')
    // const ctx = canvas.getContext('2d')
    // let data = new XMLSerializer().serializeToString(svg)
    // data = data.replace(/xmlns=\"http:\/\/www\.w3\.org\/2000\/svg\"/, '')
    // const DOMURL = window.URL || window.webkitURL || window

    // const img = new Image()
    // img.crossOrigin = 'anonymous'

    // const v = Canvg.fromString(ctx, data)
    // v.start()
    // const imgURI = canvas.toDataURL('image/png')
    // // .replace('image/png', 'image/octet-stream')

    // var a = document.createElement('a')
    // a.setAttribute('download', 'file.png')
    // a.setAttribute('href', imgURI)
    // a.setAttribute('target', '_blank')
    // a.click()

    // var svgElement = document.querySelector('.editor-container').children[0]
    // console.log(svg)

    var svgData = new XMLSerializer().serializeToString(svg)

    var canvas = document.createElement('canvas')
    canvas.width = w
    canvas.height = h

    var ctx = canvas.getContext('2d')
    var img = document.createElement('img')

    img.setAttribute(
      'src',
      'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svgData)))
    )
    img.crossOrigin = 'anonymous'
    img.onload = function () {
      ctx && ctx.drawImage(img, 0, 0)
      var imgsrc = canvas.toDataURL('image/png')

      // Create link for download
      var a = document.createElement('a')
      a.download = 'download.png'
      a.href = imgsrc
      a.click()
    }
  }
  getSvg(background: string) {
    //Disable Css Transforms if it is used

    try {
      const scale = 1
      const border = 0
      const crisp = true
      const ignoreSelection = true
      const showText = true

      var bounds = this.getGraphBounds()

      if (bounds == null) {
        throw Error(mx.mxResources.get('drawingEmpty'))
      }

      var vs = this.view.scale

      // Prepares SVG document that holds the output
      var svgDoc = mx.mxUtils.createXmlDocument()
      var root =
        svgDoc.createElementNS != null
          ? svgDoc.createElementNS(mxConstants.NS_SVG, 'svg')
          : svgDoc.createElement('svg')

      if (background != null) {
        if (root.style != null) {
          root.style.backgroundColor = background
        } else {
          root.setAttribute('style', 'background-color:' + background)
        }
      }

      if (svgDoc.createElementNS == null) {
        root.setAttribute('xmlns', mxConstants.NS_SVG)
        root.setAttribute('xmlns:xlink', mxConstants.NS_XLINK)
      } else {
        // KNOWN: Ignored in IE9-11, adds namespace for each image element instead. No workaround.
        root.setAttributeNS(
          'http://www.w3.org/2000/xmlns/',
          'xmlns:xlink',
          mxConstants.NS_XLINK
        )
      }

      var s = scale / vs
      var w = Math.max(1, Math.ceil(bounds.width * s) + 2 * border) + 0
      var h = Math.max(1, Math.ceil(bounds.height * s) + 2 * border) + 0

      root.setAttribute('version', '1.1')
      root.setAttribute('width', w + 'px')
      root.setAttribute('height', h + 'px')
      root.setAttribute(
        'viewBox',
        (crisp ? '-0.5 -0.5' : '0 0') + ' ' + w + ' ' + h
      )
      svgDoc.appendChild(root)

      // Renders graph. Offset will be multiplied with state's scale when painting state.
      // TextOffset only seems to affect FF output but used everywhere for consistency.
      var group =
        svgDoc.createElementNS != null
          ? svgDoc.createElementNS(mxConstants.NS_SVG, 'g')
          : svgDoc.createElement('g')
      root.appendChild(group)

      var svgCanvas = this.createSvgCanvas(group as SVGElement)
      svgCanvas.foOffset = crisp ? -0.5 : 0
      svgCanvas.textOffset = crisp ? -0.5 : 0
      svgCanvas.imageOffset = crisp ? -0.5 : 0
      svgCanvas.translate(
        Math.floor((border / scale - bounds.x) / vs),
        Math.floor((border / scale - bounds.y) / vs)
      )

      // Convert HTML entities
      var htmlConverter = document.createElement('div')

      // Adds simple text fallback for viewers with no support for foreignObjects
      var getAlternateText = svgCanvas.getAlternateText
      svgCanvas.getAlternateText = function (
        fo,
        x,
        y,
        w,
        h,
        str,
        align,
        valign,
        wrap,
        format,
        overflow,
        clip,
        rotation
      ) {
        // Assumes a max character width of 0.5em
        if (str != null && this.state.fontSize > 0) {
          try {
            if (mx.mxUtils.isNode(str, '')) {
              str = (str as any).innerText
            } else {
              htmlConverter.innerHTML = str
              str = mx.mxUtils.extractTextWithWhitespace(
                htmlConverter.childNodes
              )
            }

            // Workaround for substring breaking double byte UTF
            var exp = Math.ceil((2 * w) / this.state.fontSize)
            var result = []
            var length = 0
            var index = 0

            while ((exp == 0 || length < exp) && index < str.length) {
              var char = str.charCodeAt(index)

              if (char == 10 || char == 13) {
                if (length > 0) {
                  break
                }
              } else {
                result.push(str.charAt(index))

                if (char < 255) {
                  length++
                }
              }

              index++
            }

            // Uses result and adds ellipsis if more than 1 char remains
            if (result.length < str.length && str.length - result.length > 1) {
              str = mx.mxUtils.trim(result.join('')) + '...'
            }

            return str
          } catch (e) {
            return getAlternateText.apply(this, [
              fo,
              x,
              y,
              w,
              h,
              str,
              align,
              valign,
              wrap,
              format,
              overflow,
              clip,
              rotation
            ])
          }
        } else {
          return getAlternateText.apply(this, [
            fo,
            x,
            y,
            w,
            h,
            str,
            align,
            valign,
            wrap,
            format,
            overflow,
            clip,
            rotation
          ])
        }
      }

      // Paints background image
      var bgImg = this.backgroundImage
      if (bgImg != null) {
        var s2 = vs / scale
        var tr = this.view.translate
        var tmp = new mx.mxRectangle(
          tr.x * s2,
          tr.y * s2,
          bgImg.width * s2,
          bgImg.height * s2
        )

        // Checks if visible
        if (mx.mxUtils.intersects(bounds, tmp)) {
          svgCanvas.image(
            tr.x,
            tr.y,
            bgImg.width,
            bgImg.height,
            bgImg.src,
            true
          )
        }
      }

      svgCanvas.scale(s)
      svgCanvas.textEnabled = showText

      const imgExport = this.createSvgImageExport()
      var imgExportDrawCellState = imgExport.drawCellState

      // Ignores custom links
      var imgExportGetLinkForCellState = imgExport.getLinkForCellState

      imgExport.getLinkForCellState = function (state, canvas) {
        var result = imgExportGetLinkForCellState.apply(this, [state, canvas])
        return result
      }

      // Implements ignoreSelection flag
      imgExport.drawCellState = function (state, canvas) {
        var graph = state.view.graph
        var selected = graph.isCellSelected(state.cell)
        var parent = graph.model.getParent(state.cell)

        // Checks if parent cell is selected
        while (!ignoreSelection && !selected && parent != null) {
          selected = graph.isCellSelected(parent)
          parent = graph.model.getParent(parent)
        }

        if (ignoreSelection || selected) {
          imgExportDrawCellState.apply(this, [state, canvas])
        }
      }

      imgExport.drawState(this.getView().getState(this.model.root), svgCanvas)
      this.updateSvgLinks(root as SVGElement)
      // this.addForeignObjectWarning(svgCanvas, root)

      return { root, w, h }
    } finally {
    }
  }
  createSvgCanvas(node: SVGElement) {
    const canvas = new mx.mxSvgCanvas2D(node)

    canvas.pointerEvents = true

    return canvas
  }
  createSvgImageExport() {
    var exp = new mx.mxImageExport()

    // Adds hyperlinks (experimental)
    exp.getLinkForCellState = mx.mxUtils.bind(this, (state, canvas) => {
      return this.getLinkForCell(state.cell)
    })

    return exp
  }
  updateSvgLinks(node: SVGElement) {
    var links = node.getElementsByTagName('a')

    for (var i = 0; i < links.length; i++) {
      var href = links[i].getAttribute('href')

      if (href == null) {
        href = links[i].getAttribute('xlink:href')
      }
    }
  }
}

export default MyGraph
